<template>
  <div :class="isMag ? 'mag-banner' : 'wegow-banner'" class="signup-banner">
    <div class="text-center" :class="isMag ? 'mask-banner' : ''">
      <h2 v-html="isMag ? title : $t('wegow.banner.signup.title')"></h2>
      <p v-if="!isMag">{{ isMag ? "" : $t("wegow.banner.signup.subtitle") }}</p>
      <!-- <wegow-button></wegow-button> -->
      <wegow-button
        class="w-auto"
        button-id="banner-signup-button"
        background="opacity"
        color="topaz"
        :size="isMag ? 'xl' : 'banner-xxl'"
        type="button"
        :text="
          isMag
            ? $t('wegow.banner.signup.magBtn')
            : $t('wegow.banner.signup.button')
        "
        @click="
          sendGA('sign-up');
          openModal(SIGN_UP);
        "
      />
    </div>
  </div>
</template>

<script setup>
import WegowButton from "@/components/general/forms/WegowButton";
import { useModalHandler } from "@/plugins/useModalHandler";
import { onMounted } from "vue";

const { SIGN_UP, openModal } = useModalHandler();

const props = defineProps({
  title: {
    type: String,
    default: ""
  },
  subTitle: {
    type: String,
    default: ""
  },
  isMag: {
    type: Boolean,
    default: false
  }
});
const sendGA = () => {};
</script>

<style scoped lang="scss">
@mixin background-image($bg-image: "@/assets/images/signin-banner.webp") {
  background-image: url($bg-image);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white !important;
  @media screen and (min-width: $screen-md) {
    height: 370px;
  }
}
.signup-banner {
  &.wegow-banner {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    height: 170px;
    width: 100%;
    @include background-image();
    // h2 {
    //   font-size: 40px;
    //   line-height: 48px;
    // }
    h2 {
      font-size: 14px;
      text-align: center;
      opacity: 1;
      @media screen and (min-width: $screen-md) {
        font-size: 40px;
        line-height: 48px;
      }
    }
  }
  &.mag-banner {
    @include background-image("@/assets/images/banner-register-mag.webp");
    height: 370px;
    width: 100%;
    font-size: 21px;
    max-height: 201px;
    margin: auto;
    .mask-banner {
      width: 100%;
      background: rgba(0, 0, 0, 0.6);
      padding: 0 220px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media screen and (max-width: $screen-md) {
        padding: 0 20px;
      }
      h2 {
        margin-bottom: 2rem;
        font-size: 1rem;
        text-align: center;
        opacity: 1;
        @media screen and (min-width: $screen-md) {
          font-size: 21px;
          line-height: 25px;
        }
      }
    }
  }
  div {
    > h2 {
      font-weight: 700;
    }
  }

  p {
    font-weight: 400;
    font-size: 11px;
    line-height: 20px;
    margin-top: 0;
    margin-bottom: 24px;
    @media screen and (min-width: $screen-md) {
      font-size: 25px;
      line-height: 30px;
      margin-top: 11px;
      margin-bottom: 43px;
    }
  }
}
</style>
